module.exports = __webpack_public_path__ + "static/media/upskill-small.4aef9f6b.svg";